// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ZJIp[data-v-2e8c6cc4]{min-height:48px;padding:14px 33px;font-size:15px;font-style:normal;font-weight:500;line-height:20px;letter-spacing:-.23px;text-decoration:none;color:#e34084}@media screen and (min-width:1024px){.ZJIp[data-v-2e8c6cc4]{color:#aea1ce}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"comp": "ZJIp"
};
module.exports = ___CSS_LOADER_EXPORT___;
